import { MoveRight, TrendingDown, TrendingUp } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

import { Skeleton } from '@/components/skeleton'

interface MonitoringInfoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    title: string
    description: string
    value?: number | string
    status: string
  }
  isLoading: boolean
}

function getStatusIcon(status: number) {
  if (status > 0)
    return (
      <TrendingUp className="h-9 w-9 rounded-sm bg-green-500 p-1 text-white" />
    )

  if (status < 0)
    return (
      <TrendingDown className="h-9 w-9 rounded-sm bg-red-500 p-1 text-white" />
    )

  return <MoveRight className="h-9 w-9 rounded-sm bg-cyan-500 p-1 text-white" />
}

function getStatusColor(status: number) {
  if (status > 0) return 'text-green-500'
  if (status < 0) return 'text-red-500'
  return 'text-cyan-500'
}

export function MonitoringInfoCard({
  data: { title, description, status, value },
  isLoading,
  className,
}: MonitoringInfoCardProps) {
  if (isLoading) {
    return <Skeleton className="h-32 w-full max-w-80" />
  }

  if (value === undefined) return null

  const numericStatus = Number(status)

  return (
    <div
      className={twMerge(
        'flex overflow-hidden rounded-sm bg-monochromatic-200 shadow-sm',
        className,
      )}
    >
      <div className="min-w-[6px] bg-bios-primary" />
      <div className="flex flex-col gap-2 p-4 text-monochromatic-500">
        <p className="text-base font-bold">{title}</p>
        <p className="text-base">{description}</p>

        <div className="mt-auto flex items-center gap-2">
          {getStatusIcon(numericStatus)}
          <p
            className={`text-3xl font-medium text-bios-primary ${getStatusColor(numericStatus)}`}
          >
            {value}%
          </p>
        </div>
      </div>
    </div>
  )
}
